"use strict";
/**
 * AI 分析数据管理 composable
 * 用于信号选股模块的 AI 分析功能
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAIAnalysis = useAIAnalysis;
const tslib_1 = require("tslib");
const vue_demi_1 = require("vue-demi");
const request_1 = tslib_1.__importDefault(require("../assets/scripts/request"));
/**
 * 从 details 中提取第一条内容作为摘要
 */
function extractFirstContentAsSummary(details) {
    if (!details || details.length === 0) {
        return '';
    }
    for (const group of details) {
        if (group.itemList && group.itemList.length > 0) {
            return group.itemList[0].content || '';
        }
    }
    return '';
}
/**
 * 将 details 拼接成 HTML 格式内容
 * 每个分组下的 content 作为一个无序列表展示，name 加粗展示
 */
function formatDetailsToContent(details) {
    if (!details || details.length === 0) {
        return '';
    }
    const parts = [];
    for (const group of details) {
        if (!group.itemList || group.itemList.length === 0) {
            continue;
        }
        // 分组标题加粗显示
        const groupTitleHtml = group.name ? `<div class="ai-analysis-group__title"><b>${group.name}</b></div>` : '';
        // 分组内容作为无序列表
        const items = group.itemList
            .filter((item) => item.content)
            .map((item, index) => `<li class="ai-analysis-item">${index + 1}. ${item.content}</li>`)
            .join('');
        parts.push(`<div class="ai-analysis-group" style="margin-bottom: 0.1rem;">${groupTitleHtml}<ul class="ai-analysis-group__content">${items}</ul></div>`);
    }
    return parts.join('');
}
/**
 * 转换原始数据为组件使用的格式
 */
function transformAIAnalysisData(rawData) {
    // 摘要：直接取第一条内容作为摘要
    const summary = extractFirstContentAsSummary(rawData.details);
    // 标题
    const title = rawData.introTitle || '';
    // 更新时间
    const updatedTime = rawData.reportTimezoneDisplay || '';
    // 内容：将 details 拼接成 HTML
    const content = formatDetailsToContent(rawData.details);
    return {
        summary,
        title,
        updatedTime,
        content
    };
}
/**
 * AI 分析数据管理 composable
 * @returns AI 分析状态相关数据和方法
 */
function useAIAnalysis() {
    // AI 分析数据映射：stockId -> IAIAnalysisData
    const aiAnalysisMap = (0, vue_demi_1.reactive)({});
    /**
     * 批量加载 AI 分析数据
     * @param stockIds 股票 ID 列表
     */
    const loadAIAnalysis = async (stockIds) => {
        if (!stockIds || stockIds.length === 0) {
            return;
        }
        try {
            const { data: rsp } = await request_1.default.getAiStockAnalysis({
                stockIdList: stockIds.join(',')
            });
            if (rsp === null || rsp === void 0 ? void 0 : rsp.dailyReports) {
                // 遍历返回的数据，转换并存储
                for (const stockId of Object.keys(rsp.dailyReports)) {
                    const rawData = rsp.dailyReports[stockId];
                    if (rawData && rawData.details && rawData.details.length > 0) {
                        const analysisData = transformAIAnalysisData(rawData);
                        (0, vue_demi_1.set)(aiAnalysisMap, stockId, analysisData);
                    }
                }
            }
        }
        catch (e) {
            console.error('loadAIAnalysis error:', e);
        }
    };
    /**
     * 获取单个股票的 AI 分析数据
     * @param stockId 股票 ID
     */
    const getAIAnalysis = (stockId) => {
        return aiAnalysisMap[stockId];
    };
    return {
        /** AI 分析数据映射 */
        aiAnalysisMap,
        /** 批量加载 AI 分析数据 */
        loadAIAnalysis,
        /** 获取单个股票的 AI 分析数据 */
        getAIAnalysis
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQUlBbmFseXNpcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVzZUFJQW5hbHlzaXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7R0FHRzs7QUFzSUgsc0NBaURDOztBQXJMRCx1Q0FBeUM7QUFDekMsZ0ZBQWdEO0FBc0RoRDs7R0FFRztBQUNILFNBQVMsNEJBQTRCLENBQUMsT0FBaUM7SUFDbkUsSUFBSSxDQUFDLE9BQU8sSUFBSSxPQUFPLENBQUMsTUFBTSxLQUFLLENBQUMsRUFBRSxDQUFDO1FBQ25DLE9BQU8sRUFBRSxDQUFDO0lBQ2QsQ0FBQztJQUVELEtBQUssTUFBTSxLQUFLLElBQUksT0FBTyxFQUFFLENBQUM7UUFDMUIsSUFBSSxLQUFLLENBQUMsUUFBUSxJQUFJLEtBQUssQ0FBQyxRQUFRLENBQUMsTUFBTSxHQUFHLENBQUMsRUFBRSxDQUFDO1lBQzlDLE9BQU8sS0FBSyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQyxPQUFPLElBQUksRUFBRSxDQUFDO1FBQzNDLENBQUM7SUFDTCxDQUFDO0lBQ0QsT0FBTyxFQUFFLENBQUM7QUFDZCxDQUFDO0FBRUQ7OztHQUdHO0FBQ0gsU0FBUyxzQkFBc0IsQ0FBQyxPQUFpQztJQUM3RCxJQUFJLENBQUMsT0FBTyxJQUFJLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxFQUFFLENBQUM7UUFDbkMsT0FBTyxFQUFFLENBQUM7SUFDZCxDQUFDO0lBRUQsTUFBTSxLQUFLLEdBQWEsRUFBRSxDQUFDO0lBRTNCLEtBQUssTUFBTSxLQUFLLElBQUksT0FBTyxFQUFFLENBQUM7UUFDMUIsSUFBSSxDQUFDLEtBQUssQ0FBQyxRQUFRLElBQUksS0FBSyxDQUFDLFFBQVEsQ0FBQyxNQUFNLEtBQUssQ0FBQyxFQUFFLENBQUM7WUFDakQsU0FBUztRQUNiLENBQUM7UUFFRCxXQUFXO1FBQ1gsTUFBTSxjQUFjLEdBQUcsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsNENBQTRDLEtBQUssQ0FBQyxJQUFJLFlBQVksQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDO1FBRTVHLGFBQWE7UUFDYixNQUFNLEtBQUssR0FBRyxLQUFLLENBQUMsUUFBUTthQUN2QixNQUFNLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUM7YUFDOUIsR0FBRyxDQUFDLENBQUMsSUFBSSxFQUFFLEtBQUssRUFBRSxFQUFFLENBQUMsZ0NBQWdDLEtBQUssR0FBRyxDQUFDLEtBQUssSUFBSSxDQUFDLE9BQU8sT0FBTyxDQUFDO2FBQ3ZGLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztRQUVkLEtBQUssQ0FBQyxJQUFJLENBQ04saUVBQWlFLGNBQWMsMENBQTBDLEtBQUssYUFBYSxDQUM5SSxDQUFDO0lBQ04sQ0FBQztJQUVELE9BQU8sS0FBSyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztBQUMxQixDQUFDO0FBRUQ7O0dBRUc7QUFDSCxTQUFTLHVCQUF1QixDQUFDLE9BQTJCO0lBQ3hELGtCQUFrQjtJQUNsQixNQUFNLE9BQU8sR0FBRyw0QkFBNEIsQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLENBQUM7SUFFOUQsS0FBSztJQUNMLE1BQU0sS0FBSyxHQUFHLE9BQU8sQ0FBQyxVQUFVLElBQUksRUFBRSxDQUFDO0lBRXZDLE9BQU87SUFDUCxNQUFNLFdBQVcsR0FBRyxPQUFPLENBQUMscUJBQXFCLElBQUksRUFBRSxDQUFDO0lBRXhELHdCQUF3QjtJQUN4QixNQUFNLE9BQU8sR0FBRyxzQkFBc0IsQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLENBQUM7SUFFeEQsT0FBTztRQUNILE9BQU87UUFDUCxLQUFLO1FBQ0wsV0FBVztRQUNYLE9BQU87S0FDVixDQUFDO0FBQ04sQ0FBQztBQUVEOzs7R0FHRztBQUNILFNBQWdCLGFBQWE7SUFDekIsdUNBQXVDO0lBQ3ZDLE1BQU0sYUFBYSxHQUFHLElBQUEsbUJBQVEsRUFBa0MsRUFBRSxDQUFDLENBQUM7SUFFcEU7OztPQUdHO0lBQ0gsTUFBTSxjQUFjLEdBQUcsS0FBSyxFQUFFLFFBQWtCLEVBQUUsRUFBRTtRQUNoRCxJQUFJLENBQUMsUUFBUSxJQUFJLFFBQVEsQ0FBQyxNQUFNLEtBQUssQ0FBQyxFQUFFLENBQUM7WUFDckMsT0FBTztRQUNYLENBQUM7UUFFRCxJQUFJLENBQUM7WUFDRCxNQUFNLEVBQUUsSUFBSSxFQUFFLEdBQUcsRUFBRSxHQUFHLE1BQU0saUJBQU8sQ0FBQyxrQkFBa0IsQ0FBQztnQkFDbkQsV0FBVyxFQUFFLFFBQVEsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDO2FBQ2xDLENBQUMsQ0FBQztZQUVILElBQUksR0FBRyxhQUFILEdBQUcsdUJBQUgsR0FBRyxDQUFFLFlBQVksRUFBRSxDQUFDO2dCQUNwQixnQkFBZ0I7Z0JBQ2hCLEtBQUssTUFBTSxPQUFPLElBQUksTUFBTSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsWUFBWSxDQUFDLEVBQUUsQ0FBQztvQkFDbEQsTUFBTSxPQUFPLEdBQUcsR0FBRyxDQUFDLFlBQVksQ0FBQyxPQUFPLENBQXVCLENBQUM7b0JBQ2hFLElBQUksT0FBTyxJQUFJLE9BQU8sQ0FBQyxPQUFPLElBQUksT0FBTyxDQUFDLE9BQU8sQ0FBQyxNQUFNLEdBQUcsQ0FBQyxFQUFFLENBQUM7d0JBQzNELE1BQU0sWUFBWSxHQUFHLHVCQUF1QixDQUFDLE9BQU8sQ0FBQyxDQUFDO3dCQUN0RCxJQUFBLGNBQUcsRUFBQyxhQUFhLEVBQUUsT0FBTyxFQUFFLFlBQVksQ0FBQyxDQUFDO29CQUM5QyxDQUFDO2dCQUNMLENBQUM7WUFDTCxDQUFDO1FBQ0wsQ0FBQztRQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUM7WUFDVCxPQUFPLENBQUMsS0FBSyxDQUFDLHVCQUF1QixFQUFFLENBQUMsQ0FBQyxDQUFDO1FBQzlDLENBQUM7SUFDTCxDQUFDLENBQUM7SUFFRjs7O09BR0c7SUFDSCxNQUFNLGFBQWEsR0FBRyxDQUFDLE9BQWUsRUFBK0IsRUFBRTtRQUNuRSxPQUFPLGFBQWEsQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUNsQyxDQUFDLENBQUM7SUFFRixPQUFPO1FBQ0gsZ0JBQWdCO1FBQ2hCLGFBQWE7UUFDYixtQkFBbUI7UUFDbkIsY0FBYztRQUNkLHNCQUFzQjtRQUN0QixhQUFhO0tBQ2hCLENBQUM7QUFDTixDQUFDIn0=